import React from 'react';
import TextButton from '../../../../../common/Buttons/TextButton';

const label = 'Description of methodology';
const link =
  'https://metocean-on-demand.com/fileshare/getfile.ashx?type=document&file_name=DHI_-_Persistence_(Weather_Windows)_2022-03-21_.pdf';

export default function PersistenceAdditionalContent() {
  return <TextButton label={label} link={link} />;
}
